import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Shell } from "@/components/Shell";
import api from "@/lib/api";

export default function GroupJoin() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const [code, setCode] = useState(sp.get("code") || "");
  const [busy, setBusy] = useState(false);

  const join = async (c) => {
    const val = (c || code).trim().toUpperCase();
    if (!val) return;
    setBusy(true);
    try {
      const r = await api.post("/groups/join", { code: val });
      toast.success(`Gruppe „${r.data.name}" beigetreten`);
      navigate("/groups");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Fehler");
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => { if (sp.get("code")) join(sp.get("code")); /* eslint-disable-next-line */ }, []);

  return (
    <Shell back="/groups">
      <div className="space-y-5" data-testid="group-join-page">
        <h1 className="text-3xl font-heading font-semibold text-gray-900">Gruppe beitreten</h1>
        <div className="sb-card p-5 space-y-3">
          <p className="font-body text-sm text-gray-600">Gib deinen Beitrittscode ein.</p>
          <input data-testid="group-join-code" className="sb-input tracking-widest uppercase" placeholder="Beitrittscode" value={code} onChange={(e) => setCode(e.target.value)} />
          <button data-testid="group-join-submit" onClick={() => join()} disabled={busy || !code.trim()}
            className="sb-btn w-full py-3.5 text-white font-medium disabled:opacity-50" style={{ background: "var(--app-primary)" }}>Beitreten</button>
        </div>
      </div>
    </Shell>
  );
}
